module.exports = __webpack_public_path__ + "static/TiqHeader-d5bce21779d65b5178534edc36e712e3.png";